import { DisputeResponseForm } from './forms/DisputeResponseForm'
import { RefundApprovalForm } from './forms/RefundApprovalForm'
import { ChargebackResponseForm } from './forms/ChargebackResponseForm'
import { FraudAlertForm } from './forms/FraudAlertForm'
import { PaymentReviewForm } from './forms/PaymentReviewForm'
import type { ActionRequiredActivityEvent } from './types'

interface ActionDialogProps {
  event: ActionRequiredActivityEvent | null
  open: boolean
  onClose: () => void
  onSuccess?: (event: ActionRequiredActivityEvent, data: unknown) => void
}

/**
 * Routes to the correct action form dialog based on event type.
 * Keeps ActivitySection clean — a single import handles remaining dialogs.
 *
 * Each action-required event type maps to a specific form dialog.
 */
export function ActionDialog({ event, open, onClose, onSuccess }: ActionDialogProps) {
  if (!event) return null

  const handleSubmit = async (data: unknown) => {
    // Mock implementation — replace with API call when ready
    await new Promise((r) => setTimeout(r, 500))
    onSuccess?.(event, data)
    onClose()
  }

  switch (event.type) {
    case 'dispute_received':
      return (
        <DisputeResponseForm
          open={open}
          onClose={onClose}
          onSubmit={handleSubmit}
        />
      )

    case 'refund_requested':
      return (
        <RefundApprovalForm
          open={open}
          onClose={onClose}
          onSubmit={handleSubmit}
        />
      )

    case 'chargeback_received':
      return (
        <ChargebackResponseForm
          open={open}
          onClose={onClose}
          onSubmit={handleSubmit}
        />
      )

    case 'fraud_alert':
      return (
        <FraudAlertForm
          open={open}
          onClose={onClose}
          onSubmit={handleSubmit}
        />
      )

    case 'payment_under_review':
      return (
        <PaymentReviewForm
          open={open}
          onClose={onClose}
          onSubmit={handleSubmit}
        />
      )

    default:
      return null
  }
}
